$(document).ready(function () {
  // Add custom code below this line
  setInterval(function time() {
    var d = new Date();
    var d1 = new Date();
    d.setHours(d1.getHours() + 12);
    var hours = 23 - d.getHours();
    var min = 60 - d.getMinutes();
    if ((min + "").length == 1) {
      min = "0" + min;
    }
    var sec = 60 - d.getSeconds();
    if ((sec + "").length == 1) {
      sec = "0" + sec;
    }
    $(".timer").html(hours + " timer " + min + " min " + sec + " sek");

    var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    var currentDateNew = new Date(new Date().getTime() + 0 * 60 * 60 * 1000);
    var day = currentDateNew.getDate();
    let dayN = "th";
    switch (day) {
      case 1:
        dayN = "st";
        break;
      case 2:
        dayN = "nd";
        break;
      case 3:
        dayN = "rd";
        break;
      default:
        dayN = "th";
    }
    var month = currentDate.getMonth() + 1;
    var year = currentDate.getFullYear();
    var days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    $(".date-product").html(
      days[currentDateNew.getDay()] +
        ", " +
        day +
        " " +
        monthNames[currentDateNew.getMonth()]
    );

    var currentDay = days[currentDateNew.getDay()];
    var currentHour = currentDateNew.getHours();

    if (
      currentDay === "Saturday" ||
      currentDay === "Sunday" ||
      (currentDay === "Friday" && currentHour >= 12)
    ) {
      $(".timer--outer").html("Bestil nu og vi sender din pakke på mandag");
    } else if (hours >= 12) {
      $(".today-tomorrow-i").html("imorgen.");
    } else {
      $(".today-tomorrow-i").html("idag.");
    }
  }, 1000);
});


function cartClickAgree() {
  $(".Cart__Agree").click(function () {
    if ($(this).is(":checked")) {
      $(".mini-cart .button-container button").removeAttr("disabled"); //enable input
    } else {
      $(".mini-cart .button-container button").attr("disabled", true); //disable input
    }
  });
}
cartClickAgree();

$(".read-more--collection").click(function () {
  $(this).parent().slideUp().next().slideDown();
});
